export const baseColors = {
    grayscale: {
        '0000': '#FFFFFF',
        '0075': '#F5F5F5',
        '0150': '#E6E6E6',
        '0250': '#CCCCCC',
        '0375': '#A3A3A3',
        '0500': '#707070',
        '0625': '#525252',
        '0750': '#282828',
        '0875': '#191919',
        '1000': '#000000',
    },
    transparent: {
        black: {
            '0000': '#19191900',
            '0075': '#19191923',
            '0150': '#19191932',
            '0250': '#1919194C',
            '0375': '#19191975',
            '0500': '#191919A8',
            '0625': '#191919C6',
            '0750': '#191919F0',
            '0875': '#191919FF',
        },
        white: {
            '0000': '#FFFFFFFF',
            '0075': '#FFFFFFDC',
            '0150': '#FFFFFFCD',
            '0250': '#FFFFFFB3',
            '0375': '#FFFFFF8A',
            '0500': '#FFFFFF57',
            '0625': '#FFFFFF39',
            '0750': '#FFFFFF0F',
            '0875': '#FFFFFF00',
        },
    },
    blue: {
        lightest: '#e9eefb',
        light: '#a9bded',
        medium: '#3278f0',
        dark: '#285AD3',
        darker: '#394B78',
        darkest: '#081F57',
    },
    green: {
        lightest: '#E4FCEB',
        lighter: '#DCF0D7',
        light: '#72D38E',
        medium: '#50B06B',
        dark: '#128632',
        darker: '#146a49',
        darkest: '#024816',
    },
    yellow: {
        lightest: '#FFF0E2',
        lighter: '#F8D666',
        light: '#E2B626',
        medium: '#B86C26',
        darker: '#7A4412',
    },
    red: {
        lightest: '#FFECEC',
        lighter: '#FFD2D2',
        light: '#E18E9C',
        medium: '#FB0000',
        dark: '#C41E3A',
        darker: '#930000',
        darkest: '#6C0000',
    },
};
//# sourceMappingURL=baseColors.js.map